var urlUtils;

module.exports = urlUtils = {
  parseLocationHash: function() {
    return this.parseQueryString(location.hash.replace(/^#/, ''));
  },
  currentFragment: function() {
    var frag;
    frag = location.hash.replace(/^#/, '');
    if (frag.length) {
      frag = '#' + frag;
    }
    return frag;
  },
  parseQueryString: function(qs) {
    var params, ref;
    if (typeof Finch !== "undefined" && Finch !== null ? (ref = Finch.Utility) != null ? ref.parseQueryString : void 0 : void 0) {
      return Finch.Utility.parseQueryString(qs);
    } else {
      params = {};
      qs = qs.replace(/^\?/, '');
      $.each(qs.split('&'), function(c, q) {
        var i;
        i = q.split('=');
        if (i[0]) {
          return params[i[0]] = unescape(i[1]);
        }
      });
      return params;
    }
  },
  buildQueryString: function(queryMap) {
    var key, urlPath, urlQuery;
    urlQuery = [];
    urlPath = '';
    for (key in queryMap) {
      urlQuery.push(encodeURIComponent(key) + "=" + encodeURIComponent(queryMap[key]));
    }
    if (urlQuery.length) {
      urlPath = '?' + urlQuery.join('&');
    }
    return urlPath;
  },
  setFragment: function(frag) {
    var qs;
    if (history.replaceState && history.state) {
      qs = window.location.search.replace(/^\?/, '');
      if (qs.length) {
        qs = '?' + qs;
      }
      if (frag.length) {
        frag = '#' + frag;
      }
      return history.replaceState(history.state, document.title, window.location.pathname + qs + frag);
    } else {
      return location.hash = frag;
    }
  },
  apiQueryBuilder: function(opts) {
    var query_filter_string;
    query_filter_string = "";
    if (opts.filterQuery) {
      query_filter_string = "filterQuery=" + opts.filterQuery;
    } else if (opts.isCategoryFallback) {
      query_filter_string = "categoryFallback=" + opts.categoryFallback;
    } else {
      query_filter_string = "dealType=" + opts.dealType;
    }
    if (opts.context) {
      query_filter_string += "&context=" + opts.context;
    }
    if (opts.division) {
      query_filter_string += "&divisionOverride=" + opts.division;
    }
    if (opts.showOptions) {
      query_filter_string += "&showOptions=" + opts.showOptions;
    }
    if (opts.latLng && opts.filterQuery) {
      query_filter_string += "&divisionLoc=" + opts.latLng;
    }
    if (opts.pageType) {
      query_filter_string += "&pageType=" + opts.pageType;
    }
    if (opts.unsafe) {
      query_filter_string += "&unsafe=" + opts.unsafe;
    }
    if (opts.noHero) {
      query_filter_string += "&omitHero=true";
    }
    if (opts.includeHtml) {
      query_filter_string += "&includeHtml=true";
    }
    if (opts.includeQuery && window.location.search) {
      query_filter_string += window.location.search.replace(/^\?/, '&');
    }
    return query_filter_string;
  }
};

//# sourceMappingURL=data:application/json;base64,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
